import { Decision } from '@/shared/api/protocol-ts/model/dto_report_common_pb';
import { ConditionCode } from '@/shared/api/protocol-ts/model/dto_report_condition_codes_pb';
import { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';
import { TOOTH_TYPE_CODES } from '@/shared/config';

import type { AllowedConditionCodesByKey } from '../config';

import { getAllowedConditionCodesKey } from './getAllowedConditionCodesKey';

// Mirrors the server rule: the diagnosis engine keeps at most one tooth-type
// condition with a positive EngineDecision, and it already applies the user choice.
const getToothType = (toothConditions: Condition[]): ConditionCode =>
  toothConditions.find(
    (condition) =>
      TOOTH_TYPE_CODES.includes(condition.Code) &&
      condition.Certainty?.EngineDecision === Decision.PositiveDecision,
  )?.Code ?? ConditionCode.ConditionCodeInvalidValue;

export const getToothAllowedConditionCodes = (
  conditionCodesByKey: AllowedConditionCodesByKey | null,
  toothConditions: Condition[],
  toothISONumber: number,
): ConditionCode[] | undefined =>
  conditionCodesByKey?.[
    getAllowedConditionCodesKey(
      getToothType(toothConditions),
      toothISONumber % 10,
    )
  ];
